import { api } from "./api/api.service";
import { API_ERROR_LOGGER } from "./api/api.urls";


export interface IErrorLogger {
    projectName: string;
    errorMessage: string;
    errorDate: Date | string;
}

export const errorLogger = async (payload: IErrorLogger) => {
        const response = await api.post(`${API_ERROR_LOGGER}`, payload);
        return response.data;
}
